// @flow
import {
  CategoryScale, Chart as ChartJS, LinearScale, LineElement, PointElement, Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { NoData } from '../../../shared';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

type Point = { averageScore: number };

// Minimal trend sparkline for table cells - no axes, no grid.
export const QaSparkline = ({ points, color = '#1C434F' }: { points: Point[]; color?: string }) => {
  if (!points.length) return <NoData height={36} sx={{ minHeight: 36 }}>-</NoData>;
  const data = {
    labels: points.map(() => ''),
    datasets: [{
      data: points.map(p => p.averageScore),
      borderColor: color,
      borderWidth: 2,
      pointRadius: 0,
      tension: 0.4,
    }],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
    scales: { x: { display: false }, y: { display: false } },
  };
  return <div style={{ height: 36, width: '100%', position: 'relative' }}><Line data={data} options={options} /></div>;
};